// utils/number.ts
export const formatNumberWithCommas = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  // System expects empty string for zero
  if (numericValue === 0) {
    return "";
  }

  // Remove decimals without rounding
  const integerValue = Math.round(numericValue);

  return integerValue.toLocaleString();
};
export const formatNumberDecimalEnterWithCommas = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const stringValue = value.toString().replace(/,/g, "");

  if (isNaN(Number(stringValue))) {
    return "";
  }

  // Split integer & decimal parts
  const [integerPart, decimalPart] = stringValue.split(".");
  const formattedInteger = Number(integerPart).toLocaleString();

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
};

export const formatNumberDecimalWithCommas = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  // System expects empty string for zero
  if (numericValue === 0) {
    return "";
  }
  const integerValue = numericValue;

  return integerValue.toLocaleString();
};

export const formatNumberPlain = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  // System expects empty string for zero
  if (numericValue === 0) {
    return "";
  }

  // Remove decimals without rounding
  const integerValue = Math.trunc(numericValue);

  return String(integerValue);
};

export const formatNumericTwoDecimalInputWithCommas = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const numericValue = Number(String(value).replace(/,/g, ""));

  if (!Number.isFinite(numericValue)) {
    return "";
  }

  return numericValue.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const formatNumericInputWithCommas = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const rawValue = String(value).replace(/,/g, "");

  // Allow numeric input with any number of decimal places
  if (!/^\d*\.?\d*$/.test(rawValue)) {
    return "";
  }

  const [integerPart, decimalPart] = rawValue.split(".");

  const formattedInteger =
    integerPart === ""
      ? ""
      : Number(integerPart).toLocaleString("en-US");

  // Preserve decimal point while typing
  if (rawValue.includes(".")) {
    // If more than 2 decimal places, round to 2
    if (decimalPart && decimalPart.length > 2) {
      const roundedValue = Number(rawValue).toFixed(2);
      const [roundedInteger, roundedDecimal] = roundedValue.split(".");

      return `${Number(roundedInteger).toLocaleString("en-US")}.${roundedDecimal}`;
    }

    return `${formattedInteger}.${decimalPart ?? ""}`;
  }

  return formattedInteger;
};
